var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3202 24.2915C36.3202 23.3815 36.2386 22.5065 36.0869 21.6665H24.0002V26.6307H30.9069C30.6094 28.2348 29.7052 29.594 28.3461 30.504V33.724H32.4936C34.9202 31.4898 36.3202 28.1998 36.3202 24.2915Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 36.8335C27.4653 36.8335 30.3703 35.6843 32.4937 33.7243L28.3462 30.5043C27.197 31.2743 25.727 31.7293 24.0003 31.7293C20.6578 31.7293 17.8286 29.4718 16.8195 26.4385H12.532V29.7635C14.6436 33.9576 18.9836 36.8335 24.0003 36.8335Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8192 26.4385C16.5626 25.6685 16.4167 24.846 16.4167 24.0001C16.4167 23.1543 16.5626 22.3318 16.8192 21.5618V18.2368H12.5317C11.6334 20.0252 11.166 21.9989 11.1667 24.0001C11.1667 26.071 11.6626 28.031 12.5317 29.7635L16.8192 26.4385Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 16.2707C25.8845 16.2707 27.5761 16.9182 28.9061 18.1898L32.587 14.509C30.3645 12.4382 27.4595 11.1665 24.0003 11.1665C18.9836 11.1665 14.6436 14.0423 12.532 18.2365L16.8195 21.5615C17.8286 18.5282 20.6578 16.2707 24.0003 16.2707Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.572fc49d63003ee3ddd8b83bddf12c86.svg";
export { ForwardRef as ReactComponent };